import clsx from "clsx"

import { Text } from "../Text"
import styles from "./HeaderTabLink.module.css"

interface Props {
  text: string
  selected: boolean
  disabled?: boolean
  renderLink: (children: JSX.Element) => JSX.Element
}

export function HeaderTabLink(props: Props) {
  const { text, selected, disabled = false, renderLink } = props

  return (
    <div
      className={clsx(
        styles.root,
        disabled && styles.disabled,
        selected && styles.selected
      )}
    >
      {renderLink(
        <Text component="span" variant="emphasized" noSelect color="grey11">
          {text}
        </Text>
      )}
    </div>
  )
}
